/* Site-wide shipping progress banner
   Project: Veryplants CRO fixes (Apr 2026) — v2 addition

   Subscribes to PUB_SUB_EVENTS.cartUpdate so the banner updates live across
   the whole site whenever the cart changes (add to cart, qty change, item remove).
*/

(function () {
  if (customElements.get('shipping-progress-banner')) return;

  class ShippingProgressBanner extends HTMLElement {
    constructor() {
      super();
      this.threshold = Number(this.dataset.threshold) || 8000;
      this.thresholdDollars = Number(this.dataset.thresholdDollars) || 80;
      this.contentEl = this.querySelector('[data-ship-content]');
      this.unsubscribe = null;
    }

    connectedCallback() {
      // Subscribe to the theme's cart-update pubsub if available
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
        this.unsubscribe = window.subscribe(
          window.PUB_SUB_EVENTS.cartUpdate,
          () => this.refreshFromCart()
        );
      }
      // Belt and braces: also listen for the legacy event Dawn dispatches
      document.addEventListener('cart:updated', () => this.refreshFromCart());
    }

    disconnectedCallback() {
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
    }

    async refreshFromCart() {
      try {
        const r = await fetch('/cart.js', { cache: 'no-store' });
        if (!r.ok) return;
        const cart = await r.json();
        this.render(cart);
      } catch (e) {
        // Silent fail — server-rendered fallback already in place
      }
    }

    render(cart) {
      const itemCount = cart.item_count || 0;
      const currentCents = cart.total_price || 0;
      const remainingCents = Math.max(0, this.threshold - currentCents);
      const pct = Math.min(100, Math.round((currentCents / this.threshold) * 100));

      let html;
      if (itemCount === 0) {
        html = `<span class="ship-banner__text">Free shipping on orders over <strong>$${this.thresholdDollars}</strong>.</span>`;
      } else if (remainingCents > 0) {
        html = `
          <span class="ship-banner__text">
            You're <strong data-ship-amount>${this.formatMoney(remainingCents)}</strong> away from <strong>free shipping</strong>.
          </span>
          <div class="ship-banner__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${pct}">
            <div class="ship-banner__fill" data-ship-fill style="width: ${pct}%"></div>
          </div>
        `;
      } else {
        html = `<span class="ship-banner__text ship-banner__text--unlocked">🎉 <strong>Free shipping unlocked.</strong> Your order qualifies.</span>`;
      }
      if (this.contentEl) this.contentEl.innerHTML = html;
    }

    formatMoney(cents) {
      // Remove trailing .00 if integer dollar amount
      const dollars = cents / 100;
      const formatted = Number.isInteger(dollars) ? `$${dollars}` : `$${dollars.toFixed(2)}`;
      if (window.Shopify && Shopify.formatMoney) {
        try {
          return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
        } catch (e) {}
      }
      return formatted;
    }
  }

  customElements.define('shipping-progress-banner', ShippingProgressBanner);
})();
